import { http } from './http'

export const AuthApi = {
  register: (p: { email: string; password: string; businessName: string; slug: string }) =>
    http.post('/api/auth/register', p),
  login: (p: { email: string; password: string }) => http.post('/api/auth/login', p),
  logout: () => http.get('/api/auth/logout'),
  InitUserInfo: () => http.get('/api/auth/init-user-info', { withCredentials: true }),
  updateTenantInfo: (p: {
    phoneNumber?: string
    email?: string
    address?: string
    instagram?: string
    facebook?: string
    twitter?: string
  }) => http.post('/api/auth/update-tenant-info', p),
  getTenantInfo: () => http.get('/api/auth/get-tenant-info'),
  reissue: () => http.post('/api/auth/reissue'),
}
